import React, {useLayoutEffect, useState} from 'react';
import { Helmet } from 'react-helmet';
import IndexMobile from './index/mobile';
import IndexDesktop from './index/desktop';
import WindowHelper from '../page-helpers/window-obj';

const title = 'Keus – Best Smart Home Automation Company in Hyderabad';
const description = 'KEUS is the leading home automation company from Hyderabad. Experience the true power of home automation and smart home system with Keus Smart Home.';
const keywords = 'home automation in hyderabad, home automation, home automation system, smart home system, smart home automation, google home automation, best smart home system, best home automation system, alexa home automation, home automation companies, best home automation, home automation companies in hyderabad';

export default (props) => {
    const [isMobile, setMobileFlag] = useState(false);

    useLayoutEffect(() => {
        setMobileFlag(WindowHelper.isMobile);
    });

    return (
        <div>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="keywords" content={keywords} />
                <meta property="og:url" content="https://keus.in" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
            </Helmet>
            {isMobile ? <IndexMobile /> : <IndexDesktop />}
        </div>
    );
}
